import { render, staticRenderFns } from "./CobranzaForm.vue?vue&type=template&id=08d4e14c&"
import script from "./CobranzaForm.vue?vue&type=script&lang=js&"
export * from "./CobranzaForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator,QForm,QInput,QCardActions,QInnerLoading,QSpinner,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator,QForm,QInput,QCardActions,QInnerLoading,QSpinner})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
